import classnames from "classnames";
import { useEffect, useState } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

import RequireAuth from "../../components/RequireAuth";
import RequireRemiTeam from "../../components/RequireRemiTeam";
import { ERROR_MESSAGE } from "../../constants";
import Page from "../../templates/Page";
import ErrorBoundary from "../../utils/ErrorBoundary";
import Admin from "../Admin";
import AdminAddUser from "../Admin/addUser";
import ClientQuestionnaire from "../ClientQuestionnaire";
import ClientQuestionnaires from "../ClientQuestionnaires";
import Proposal from "../Proposal";
import Proposals from "../Proposals";
import Report from "../Report";
import UserFlow from "../UserFlow";

import WeeklyReports from "../WeeklyReports";
import "./app.scss";

function App() {
  const [pointers, setPointers] = useState(true);
  const [tab, setTab] = useState();
  const isProdEnv = process.env.REACT_APP_ENV === `production`;
  function handleFirstTab(e) {
    if (e.key === "Tab") {
      setPointers();
      setTab(true);

      document.removeEventListener("keydown", handleFirstTab);
      document.addEventListener("pointerdown", handleMouseDownOnce);
    }
  }

  function handleMouseDownOnce() {
    setPointers(true);
    setTab();

    document.removeEventListener("pointerdown", handleMouseDownOnce);
    document.addEventListener("keydown", handleFirstTab);
  }

  useEffect(() => {
    document.addEventListener("pointerdown", handleMouseDownOnce);
    document.addEventListener("keydown", handleFirstTab);

    return () => {
      document.removeEventListener("pointerdown", handleMouseDownOnce);
      document.removeEventListener("keydown", handleFirstTab);
    };
  });

  return (
    <div
      className={classnames({ "using-pointers": pointers, "using-tab": tab })}
    >
      <Router>
        <ErrorBoundary
          fallback={
            <Page
              template="nomatch"
              subtitle={ERROR_MESSAGE.SUBTITLE}
              description={ERROR_MESSAGE.DESCRIPTION.GENERAL}
            />
          }
        >
          <Routes>
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Page />
                </RequireAuth>
              }
            >
              <Route
                index
                element={<Navigate to="/proposals" replace={true} />}
              />
              <Route path="proposals">
                <Route index element={<Proposals />} />
                <Route path="add" element={<Proposal />} />
                <Route path=":id" element={<Proposal />} />
              </Route>
              <Route path="duplicate">
                <Route index element={<Navigate to="/proposals/add" />} />
                <Route path=":id" element={<Proposal />} />
              </Route>

              {!isProdEnv && (
                <Route path="client-questionnaires">
                  <Route index element={<ClientQuestionnaires />} />
                  <Route path="add">
                    <Route
                      path=":proposalId"
                      element={<ClientQuestionnaire />}
                    />
                  </Route>
                  <Route
                    path=":questionnaireId"
                    element={<ClientQuestionnaire />}
                  />
                </Route>
              )}
            </Route>
            <Route
              path="reports"
              element={
                <RequireAuth>
                  <Page template="report" />
                </RequireAuth>
              }
            >
              <Route index element={<Navigate to="/proposals" />} />
              <Route path=":id" element={<Report />} />
            </Route>
            <Route
              path="reports"
              element={
                <RequireAuth>
                  <Page template="report" />
                </RequireAuth>
              }
            >
              <Route index element={<Navigate to="/proposals" />} />
              <Route path=":id" element={<Report />} />
            </Route>
            <Route
              path="admin"
              element={
                <RequireAuth checkIsAdmin>
                  <Page />
                </RequireAuth>
              }
            >
              <Route index element={<Admin />} />
              <Route path="users" element={<Admin />} />
              <Route path="users/add" element={<AdminAddUser />} />
            </Route>
            <Route path="signin" element={<UserFlow type="signin" />} />
            <Route
              path="request-password"
              element={<UserFlow type="request-password" />}
            />
            <Route
              path="reset-password"
              element={<UserFlow type="reset-password" />}
            />
            <Route
              path="new-user"
              element={<UserFlow type="new-password-challenge" />}
            />
            <Route
              path="weekly-reports"
              element={
                <RequireRemiTeam>
                  <WeeklyReports />
                </RequireRemiTeam>
              }
            />
            <Route
              path="unauthorized"
              element={
                <Page
                  template="nomatch"
                  subTitle="Unauthorized Access"
                  description="Your user permissions prevent you from being able to view this page or there is an issue with your user session."
                  status={403}
                />
              }
            />
            <Route
              path="*"
              element={<Page template="nomatch" status={404} />}
            />
          </Routes>
        </ErrorBoundary>
      </Router>
    </div>
  );
}

export default App;
